/* eslint-disable no-new */
import "../scss/collection.scss";
import { defaultSortBy } from "../components/sort-by";
import { toggleDataActive, toggleFilterDesktop } from "../utils/toggle-dataset";
import { rangeFilters } from "../components/filters-range";
import { filterCollection } from "../components/filter";

import { CollectionCard } from "../components/collection-card";

defaultSortBy();
rangeFilters();

toggleFilterDesktop("#filter-open", "#filter");

toggleDataActive(
  '#filter-open-mobile',
  '#filter-mobile',
  {
    overlay: true,
  }
)

toggleDataActive(
  '.filter-form__name svg',
  '#filter-mobile',
  {
    overlay: true,
  }
)

filterCollection();

new CollectionCard();
